import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Lottie from "lottie-react";
import successAnimation from "../Assets/success.json";
import failAnimation from "../Assets/fail.json";
import "../Style/PaymentSuccess.css"; // Import the CSS file
import { useAppointment } from "./AppointmentContext.js";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const { setAppointmentData } =
    useAppointment();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      navigate("/");
      setAppointmentData(true);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="payment-main-container">
      <div className="payment-popup">
        <h2>Payment Status</h2>
        <div>
          <p className="fail-text">❌ Payment Failed!</p>
          <Lottie
            animationData={failAnimation}
            style={{ width: 200, height: 200 }}
          />
          <p className="redirect-message">
            Redirecting in {countdown} seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
